import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import { Form } from '@ant-design/compatible';
import { filter, includes } from 'lodash';
import TagGroupEditWrap from '../../views/tag/group/edit/TagGroupEditWrap';
import { appActions } from '../../store/modules/app';
import { tagActions } from '../../store/modules/tag';
import { _LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { TAG_LINK_LIST_FILTER_OPTION_MODEL, TAG_LINK_LIST_SORT_OPTION_MODEL } from '../../store/modules/tag/models';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../constants/service/common/utilConstants';
import { setTrim, asyncSimpleModal } from '../../lib/common';

class TagGroupEditContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = () => {
    this.getTagGroupItemList({
      filterOption: TAG_LINK_LIST_FILTER_OPTION_MODEL,
      sortOption: TAG_LINK_LIST_SORT_OPTION_MODEL,
      pagination: _LIST_PAGINATION_MODEL,
    });
  };

  /**
   *  태그 등록/편집 하기
   */
  onSubmit = async () => {
    const { form, tagGroupEdit, onSubmit } = this.props;
    const { tagGroupInfo, tagGroupItem, editableTagGroup } = tagGroupEdit;

    if (!editableTagGroup) {
      await asyncSimpleModal({
        type: 'warning',
        title: '카테고리로 설정된 태그 그룹입니다.',
        message: '카테고리로 설정된 태그그룹은 수정할 수 없습니다. 카테고리 생성/삭제 페이지에서 해제 후 수정해주세요.',
      });
      return;
    }

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 150, offsetTop: 150 } }, async (err) => {
      if (err) return;

      /**
       *  태그 그룹명 중복 검사 체크
       */
      if (tagGroupInfo.isDuplicationTagGroupName) {
        message.error('이미 등록된 태그 그룹명입니다.');
        return;
      }

      onSubmit({
        /**
         *  태그 그룹 정보
         */
        tagGroupInfo: {
          /**
           *  태그 그룹 id
           */
          tagGroupId: tagGroupInfo.tagGroupId,
          /**
           *  태그 그룹명
           */
          tagGroupName: setTrim(tagGroupInfo.tagGroupName),
          /**
           *  태그 그룹 타입
           */
          tagGroupType: tagGroupInfo.tagGroupType,
        },
        /**
         *  태그 그룹에 연결된 아이템
         */
        tagGroupItemTagIdList: tagGroupItem.selectedItemList.idList,
      });
    });
  };

  /**
   *  태그 그룹명 중복검사하기
   */
  onChangeTagGroupName = (value) => {
    const { setData, checkTagGroupName, tagGroupEdit } = this.props;
    const { tagGroupInfo } = tagGroupEdit;

    setData({
      path: ['tagGroupEdit', 'tagGroupInfo', 'tagGroupName'],
      value,
    });

    const targetTagGroupName = setTrim(value);

    if (targetTagGroupName && targetTagGroupName.length) {
      checkTagGroupName({
        tagGroupName: targetTagGroupName,
        tagGroupId: tagGroupInfo.tagGroupId,
      });
    }
  };

  /**
   *  태그 그룹에 연결할 아이템 리스트 불러오기
   */
  getTagGroupItemList = (option) => {
    const { getTagGroupItemList, tagGroupEdit } = this.props;
    const { tagGroupItem } = tagGroupEdit;
    const { filterOption, sortOption, pagination } = tagGroupItem.itemList;

    getTagGroupItemList({
      filterOption,
      sortOption,
      pagination,
      ...option,
    });
  };

  /**
   *  태그 그룹에 연결할 아이템 선택하기
   */
  selectTagGroupItemList = async (action, moveIdList) => {
    const { setData, tagGroupEdit } = this.props;
    const { tagGroupItem } = tagGroupEdit;
    const { itemList, selectedItemList } = tagGroupItem;

    /**
     *  업데이트 될 선택된 태그 그룹에 연결할 아이템 리스트
     */
    let updatedSelectTagGroupItemList = [];

    /**
     * 태그에 연결할 아이템 아이템 추가
     */
    if (action === 'add') {
      let targetList = filter(itemList.list, (item) => includes(moveIdList, item.id));

      /**
       *  이전에 선택되어 있던 아이템 리스트와
       *  추가로 선택된 위젯 아이템을 합침
       */
      updatedSelectTagGroupItemList = [...targetList, ...selectedItemList.list];
    } else if (action === 'remove') {
      /**
       * 태그에 연결할 아이템 아이템 해제
       */
      /**
       *  이전에 선택되어 있던 아이템 리스트에서
       *  해제한 위젯아이템을 빼버림
       */
      updatedSelectTagGroupItemList = filter(selectedItemList.list, (item) => !includes(moveIdList, item.id));
    }

    /**
     *  선택되어진 선택된 아이템은
     *  선택할 수 없도록 함
     */
    const updatedTagRelatedItemList = itemList.list.map((item) => ({
      ...item,
      uncheckable: includes(moveIdList, item.id) ? action === 'add' : item.uncheckable,
    }));
    setData({
      path: ['tagGroupEdit', 'tagGroupItem', 'itemList', 'list'],
      value: updatedTagRelatedItemList,
    });

    /**
     *  선택된 아이템 업데이트하기
     */
    setData({
      path: ['tagGroupEdit', 'tagGroupItem', 'selectedItemList'],
      value: {
        list: updatedSelectTagGroupItemList,
        idList: updatedSelectTagGroupItemList.map((item) => item.id),
      },
    });
  };

  /**
   *  전체 태그 리스트 엑셀 다운로드
   */
  getTagGroupAllListExcelDownload = () => {
    const { getTagGroupAllListExcelDownload, tagGroupEdit } = this.props;

    getTagGroupAllListExcelDownload({
      filterOption: tagGroupEdit.tagGroupItem.itemList.filterOption,
      sortOption: tagGroupEdit.tagGroupItem.itemList.sortOption,
    });
  };

  /**
   *  선택된 태그 리스트 엑셀 다운로드
   */
  getTagGroupSelectedListExcelDownload = () => {
    const { getTagGroupSelectedListExcelDownload, tagGroupEdit } = this.props;
    const { idList } = tagGroupEdit.tagGroupItem.selectedItemList;

    if (!idList.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getTagGroupSelectedListExcelDownload({
      tagIdList: idList,
    });
  };

  /**
   *  태그 엑셀 업로드
   */
  setTagGroupExcelUpload = (file) => {
    const { setTagGroupExcelUpload } = this.props;

    setTagGroupExcelUpload({
      attachment: [file],
    });
  };

  render() {
    const { form, tagGroupEdit, setData, getRelatedTagList } = this.props;

    return (
      <TagGroupEditWrap
        form={form}
        setData={setData}
        tagGroupEdit={tagGroupEdit}
        getRelatedTagList={getRelatedTagList}
        onChangeTagGroupName={this.onChangeTagGroupName}
        onSubmit={this.onSubmit}
        getTagGroupItemList={this.getTagGroupItemList}
        selectTagGroupItemList={this.selectTagGroupItemList}
        getTagGroupAllListExcelDownload={this.getTagGroupAllListExcelDownload}
        getTagGroupSelectedListExcelDownload={this.getTagGroupSelectedListExcelDownload}
        setTagGroupExcelUpload={this.setTagGroupExcelUpload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tagGroupEdit: state.tag.tagGroupEdit,
  };
};

const mapDispatchToProps = {
  setData: tagActions.setData,
  checkTagGroupName: tagActions.checkTagGroupName,
  getTagGroupItemList: tagActions.getTagGroupItemList,
  getTagGroupAllListExcelDownload: tagActions.getTagGroupAllListExcelDownload,
  getTagGroupSelectedListExcelDownload: tagActions.getTagGroupSelectedListExcelDownload,
  setTagGroupExcelUpload: tagActions.setTagGroupExcelUpload,
  getRelatedTagList: appActions.getRelatedTagList,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(TagGroupEditContainer));
